import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    tracking: {
        tagmanager: {
            tagCode: 'GTM-H68D',
        },
    },
    host: 'www.zalando-lounge.de',
});
